import { render } from "./UpdateRolePermissionPage.vue?vue&type=template&id=3b8feecc&ts=true"
import script from "./UpdateRolePermissionPage.vue?vue&type=script&lang=ts"
export * from "./UpdateRolePermissionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__